import { render, staticRenderFns } from "./CmgBanner.vue?vue&type=template&id=437b9f25&scoped=true&lang=pug&"
import script from "./cmg-banner.ts?vue&type=script&lang=ts&"
export * from "./cmg-banner.ts?vue&type=script&lang=ts&"
import style0 from "./CmgBanner.vue?vue&type=style&index=0&id=437b9f25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b9f25",
  null
  
)

export default component.exports